<script>
import FormElement from '@wielink-application/shared/vue/components/form/horizontal/color.vue'

export default FormElement;
</script>